// extracted by mini-css-extract-plugin
export default {"item":"item_Hints-module_3OK9O"};